import { useInsuranceDataContext } from '~/hooks/insurance-data-provider/useInsuranceDataContext';

export function useUpdateFilledQuoteFormValues() {
  const context = useInsuranceDataContext();

  return context.updateFilledQuoteFormValues;
}
